import { CrmProvider } from "@/pages/Private/redux/crm/crm.schema";

import type { TFunction } from "i18next";

/**
 * The "Add to <CRM>" label of every provider, in menu order. A `Record` over the enum, so a
 * sixth provider does not compile until it has a label here.
 *
 * Every bulk "Add to CRM" menu builds its entries from this map. The Contacts action bar used to
 * hard-code HubSpot, Zoho and Pipedrive while its button showed for any connected CRM, so a
 * workspace connected only to Dynamics or Salesforce got an empty menu (PREC-4326).
 */
export const CRM_ADD_TO_LABEL_KEYS: Record<CrmProvider, string> = {
	[CrmProvider.HUBSPOT]: "basics.addToHubspot",
	[CrmProvider.ZOHO]: "basics.addToZoho",
	[CrmProvider.PIPEDRIVE]: "basics.addToPipedrive",
	[CrmProvider.MSDYNAMICS]: "basics.addToDynamics",
	[CrmProvider.SALESFORCE]: "basics.addToSalesforce",
};

export interface CrmAddToMenuEntry {
	provider: CrmProvider;
	label: string;
}

/** The menu entries for the connected providers, in menu order. Empty when none is connected. */
export const crmAddToMenuEntries = (
	connectedProviders: CrmProvider[],
	t: TFunction
): CrmAddToMenuEntry[] =>
	(Object.keys(CRM_ADD_TO_LABEL_KEYS) as CrmProvider[])
		.filter((provider) => connectedProviders.includes(provider))
		.map((provider) => ({ provider, label: t(CRM_ADD_TO_LABEL_KEYS[provider]) }));
